export const StarIcon = ({ width = '16', height = '16' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 17" fill="none">
      <path d="M8 2.68359V15.0169" stroke="#0050C7" stroke-linecap="square" />
      <path d="M14.168 8.84961L1.83463 8.84961" stroke="#0050C7" stroke-linecap="square" />
      <path d="M12.3613 4.48828L3.64034 13.2093" stroke="#0050C7" stroke-linecap="square" />
      <path d="M12.3613 13.2109L3.64035 4.48995" stroke="#0050C7" stroke-linecap="square" />
    </svg>
  );
};
